export const ZONE_TYPE_WAVE = 11;
export const ZONE_TYPE_SEDI = 15;

export const USE_STUB_API = false;

export const DEFAULT_ZONE_TYPE = ZONE_TYPE_WAVE;

// Типы, доступные в фильтре на списке зон. Зоны для СеДи (15) доступны только для просмотра.
export const ZONE_TYPES = [
    { id: ZONE_TYPE_WAVE, labelId: "zones.type.wave" },
    { id: ZONE_TYPE_SEDI, labelId: "zones.type.sedi" },
];

export const ZONE_TYPE_OPTIONS = [
    { id: 1, labelId: "zones.type.1" },
    { id: 2, labelId: "zones.type.2" },
    { id: 3, labelId: "zones.type.3" },
    { id: 4, labelId: "zones.type.4" },
    { id: 5, labelId: "zones.type.5" },
    { id: 6, labelId: "zones.type.6" },
    { id: 7, labelId: "zones.type.7" },
    { id: ZONE_TYPE_WAVE, labelId: "zones.type.wave" },
];

// Источники для импорта — только типы 1–7; из волнового (11) в волновой импортировать нельзя,
// а типы 8–10 не используются и в интерфейсе не показываются.
export const IMPORT_SOURCE_ZONE_TYPE_OPTIONS = ZONE_TYPE_OPTIONS.filter((t) => t.id !== ZONE_TYPE_WAVE);

export const isImportSourceZoneType = (typeId) =>
    IMPORT_SOURCE_ZONE_TYPE_OPTIONS.some((t) => t.id === Number(typeId));

export const getZoneTypeLabelId = (typeId) => {
    const option = ZONE_TYPE_OPTIONS.find((t) => t.id === Number(typeId));
    return option ? option.labelId : null;
};

export const EDITABLE_ZONE_TYPES = [ZONE_TYPE_WAVE];

export const isEditableZoneType = (typeId) => EDITABLE_ZONE_TYPES.includes(Number(typeId));

const TIMEZONES_RU = ["SAMT", "KALT", "MSK", "OMST", "KRAT", "MAGT", "PETT", "IRKT", "YAKT", "VLAT", "YEKT"];
const TIMEZONES_FR = ["WET", "CET", "EET"];

export const TIMEZONES = process.env.REACT_APP_LOCALE === "fr_FR" ? TIMEZONES_FR : TIMEZONES_RU;
